module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么不能直接引用 cdn 链接")]), _vm._v(" "), _c('p', [_vm._v("原因见 "), _c('router-link', {
    attrs: {
      "to": "/zh-CN/faq/why-use-vue-file-for-distribution.html"
    }
  }, [_vm._v("为什么使用 .vue 源码分发而不是 js 文件")]), _vm._v("。因为并不会在源码里提供 umd 脚本也不会在发布时发布 umd 脚本，因此没有 cdn 链接。")], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a1badce8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-a1badce8"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/why-cannot-i-use-vux-with-cdn-22.vue
// module id = 2413
// module chunks = 185